import { getAgentProfile } from "rc-app/api/agentActionsApi";
import { getAgencyById } from "rc-app/api/agencyActionsApi";
import { getCustomerList } from "rc-app/api/customerActionsApi";
import { getFullProjectData } from "rc-app/api/projectActionsApi";
import {
  getClientAdminByEmailId,
  getClientManagerByEmailId,
} from "rc-app/api/systemBusinessAdminActionApi";
import { AddButton } from "rc-app/components/Buttons";
import Icon from "rc-app/components/Icons";
import UserService from "rc-app/services/UserService";
import { capitalizeWords, toPascalCase } from "rc-app/utils";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const ProjectList: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();

  const [projects, setProjects] = useState<any[]>([]);
  const [filteredProjects, setFilteredProjects] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showUniqueUnitsModal, setShowUniqueUnitsModal] = useState(false);
  const [selectedUnits, setSelectedUnits] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  const [clientManger, setClientManager] = useState();
  const [agencyId, setAgencyId] = useState();
  // Project IDs the logged-in lead is restricted to (Phase I curation). Empty =
  // no restriction → sees ALL agency projects (today's default; future projects
  // auto-appear). A non-empty list curates the Projects tile to just those IDs.
  // Sourced from the customer's engaged_project_ids; "all" is never stored,
  // it's simply the absence of a restriction.
  const [visibleProjectIds, setVisibleProjectIds] = useState<string[]>([]);

  const fetchProjectList = (clientId: any) => {
    setIsLoading(true);
    getFullProjectData(clientId)
      .then((res: any) => {
        console.log("projectList 2", res);
        setProjects(res || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false); // Stop loading
      });
  };

  useEffect(() => {
    const email = UserService.getUseremail();
    {
      UserService.hasRole("agency_business_admin") &&
        getClientManagerByEmailId(email)
          .then((res) => {
            console.log("clientManger 2", res);
            setClientManager(res?.agency_business_admin);
            setAgencyId(res?.agency_business_admin?.agency_id);
            fetchProjectList(res?.agency_business_admin?.agency_id);
          })
          .catch((error) => {
            console.error("Error fetching client manager:", error);
            console.error("Error response:", error.response);
            setIsLoading(false);
          });
    }

    {
      UserService.hasRole("agency_system_admin") &&
        getClientAdminByEmailId(UserService.getUseremail())
          .then((res) => {
            setAgencyId(res?.agency_system_admin?.agency_id);
            fetchProjectList(res?.agency_system_admin?.agency_id);
            console.log(
              "agency_system_admin 6",
              res?.agency_system_admin?.agency_id,
            );
          })
          .catch((error) => {
            console.error("Error fetching client manager:", error);
            console.error("Error response:", error.response);
            setIsLoading(false);
          });
    }

    {
      UserService.hasRole("agent") &&
        getAgentProfile(UserService.getUseremail())
          .then((res) => {
            setAgencyId(res?.agent?.agency["id"]);
            fetchProjectList(res?.agent?.agency["id"]);
            console.log("agency_system_admin 6", res);
          })
          .catch((error) => {
            console.error("Error fetching client manager:", error);
            console.error("Error response:", error.response);
            setIsLoading(false);
          });
    }

    if (UserService.hasRole("customer")) {
      const resolveAndLoad = async () => {
        try {
          let agencies: any[] = [];
          const cached = sessionStorage.getItem("customerAgencies");
          if (cached) {
            agencies = JSON.parse(cached);
          } else {
            // Fresh session — clear any stale selection flag so the selector shows again
            sessionStorage.removeItem("customerAgencySelected");
            // Query all customer records for this email (one per agency)
            const listRes = await getCustomerList(0, 100, "", "", "", email);
            const records: any[] = listRes?.re_customer_list || [];
            const agencyMap = new Map<string, any>();
            for (const record of records) {
              const aId = record?.agency_id;
              if (aId && !agencyMap.has(aId)) {
                const agencyData = await getAgencyById(aId);
                if (agencyData?.slug) {
                  agencyMap.set(aId, { id: aId, slug: agencyData.slug, name: agencyData.name || "", logo: agencyData.logo || "", engagedProjectIds: Array.isArray(record?.engaged_project_ids) ? record.engaged_project_ids.map(String) : [] });
                }
              }
            }
            agencies = Array.from(agencyMap.values());
            sessionStorage.setItem("customerAgencies", JSON.stringify(agencies));
          }

          if (agencies.length > 1 && !sessionStorage.getItem("customerAgencySelected")) {
            navigate("/agency-select", { replace: true });
            return;
          }

          const target = agencies.find((a: any) => a.slug === slug) ?? agencies[0];
          if (target?.id) {
            setAgencyId(target.id);
            setVisibleProjectIds(
              Array.isArray(target?.engagedProjectIds)
                ? target.engagedProjectIds.map(String)
                : [],
            );
            fetchProjectList(target.id);
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          console.error("[ProjectList] Error fetching customer projects:", error);
          setIsLoading(false);
        }
      };
      resolveAndLoad();
    }
  }, []);

  console.log("clientManger", clientManger, agencyId);

  useEffect(() => {
    let filtered = [...projects];

    if (searchTerm) {
      filtered = filtered.filter(
        (project) =>
          project.project_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          project.agency_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          project.address?.city
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          project.address?.landmark
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          project.address?.postal_code
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          project.address?.country
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()),
      );
    }

    if (filterType !== "all") {
      filtered = filtered.filter(
        (project) => project.project_type === filterType,
      );
    }

    // Per-lead project visibility (Phase I curation): a lead whose
    // engaged_project_ids is non-empty sees ONLY those projects; empty/absent
    // means no restriction → sees all agency projects (today's default, future
    // projects auto-appear). Non-customer roles never set this, so they're
    // unaffected. "all" is never materialised — it's just the empty case.
    if (visibleProjectIds.length > 0) {
      filtered = filtered.filter((project) =>
        visibleProjectIds.includes(String(project._id)),
      );
    }

    // Sort by display_order ASC (super_admin-curated marketplace order),
    // falling back to created_at DESC for unset projects and ties.
    // The /views/projects endpoint doesn't sort server-side yet, so we
    // enforce it here. Harmless when backend eventually adds it.
    filtered.sort((a: any, b: any) => {
      const aOrder = a?.display_order ?? Number.POSITIVE_INFINITY;
      const bOrder = b?.display_order ?? Number.POSITIVE_INFINITY;
      if (aOrder !== bOrder) return aOrder - bOrder;
      const aTime = new Date(a?.created_at || 0).getTime();
      const bTime = new Date(b?.created_at || 0).getTime();
      return bTime - aTime;
    });

    setFilteredProjects(filtered);
    console.log("searchTerm xxx", searchTerm, filtered);
  }, [projects, searchTerm, filterType, visibleProjectIds]);

  const handleDeleteProject = (projectId: string) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      const updatedProjects = projects.filter(
        (project) => project._id !== projectId,
      );
      setProjects(updatedProjects);
    }
  };

  const handleViewDetails = (project: any) => {
    setSelectedProject(project);
    setShowDetailsModal(true);
  };

  const handleViewUniqueUnits = (project: any) => {
    setSelectedProject(project);
    const units = project.project_type_details?.unit_configurations || [];
    setSelectedUnits(units);
    setShowUniqueUnitsModal(true);
  };

  const getPropertyTypeLabel = (type: string) => {
    const typeMap: { [key: string]: string } = {
      villa_gated_community: "Villa in Gated Community",
      apartment: "Apartment",
      farmland: "Farmland",
      bungalow: "Bungalow",
      commercial_space: "Commercial Space",
      layout_gated_community: "Layout in Gated Community",
    };
    return typeMap[type] || type;
  };

  const getProjectStats = (project: any) => {
    const propType = project.project_type;
    const propDetails = project.project_type_details;

    switch (propType) {
      case "villa_gated_community":
        return {
          type: "Villa in Gated Community",
          units: propDetails?.unit_configurations?.[0]?.count || "N/A",
          floors: propDetails?.number_of_floors || "N/A",
          clubhouse: propDetails?.clubhouse_size_sqft
            ? `${propDetails.clubhouse_size_sqft} sqft`
            : "N/A",
        };
      case "apartment":
        return {
          type: "Apartment",
          towers: propDetails?.number_of_towers || "N/A",
          floors: propDetails?.number_of_floors || "N/A",
          units:
            propDetails?.unit_configurations?.reduce(
              (sum: number, config: any) => sum + (config.count || 0),
              0,
            ) || "N/A",
          clubhouse: propDetails?.clubhouse_size_sqft
            ? `${propDetails.clubhouse_size_sqft} sqft`
            : "N/A",
        };
      case "farmland":
        return {
          type: "Farmland",
          area: propDetails?.total_area_in_acres
            ? `${propDetails.total_area_in_acres} acres`
            : "N/A",
          plots: propDetails?.number_of_plots || "N/A",
        };
      default:
        return {
          type: getPropertyTypeLabel(propType),
          units: propDetails?.unit_configurations?.[0]?.count || "N/A",
        };
    }
  };

  const handleExportProjects = () => {
    const dataStr = JSON.stringify(projects, null, 2);
    const dataUri =
      "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);
    const exportFileDefaultName = `projects_export_${
      new Date().toISOString().split("T")[0]
    }.json`;

    const linkElement = document.createElement("a");
    linkElement.setAttribute("href", dataUri);
    linkElement.setAttribute("download", exportFileDefaultName);
    linkElement.click();
  };

  const handleClearAllProjects = () => {
    if (
      window.confirm(
        "Are you sure you want to delete ALL projects? This action cannot be undone.",
      )
    ) {
      setProjects([]);
      setFilteredProjects([]);
    }
  };
  console.log("projectsddd", projects);

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] p-3 sm:p-4 md:p-6">
        <div className="mb-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-2">
            <div className="flex items-center gap-1 text-sm">
              <button
                type="button"
                onClick={() => navigate(slug ? `/c/${slug}` : "/")}
                className="text-[#889DB2] hover:underline"
              >
                Home
              </button>
              <span className="text-[#889DB2] mx-1">›</span>
              <span className="text-white font-medium">
                My Projects ({projects.length})
              </span>
            </div>
            <div className="flex flex-row gap-3 md:gap-4 w-full md:w-auto">
              <div className="relative flex-1 md:flex-none">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-12 w-full sm:w-85 px-3 py-2 text-[#F4F5F7] rounded-md bg-[#2E4051] border-none focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors placeholder:text[#889DB2]"
                />
                <Icon
                  name="ic-search"
                  className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4"
                />
              </div>
              {(UserService.hasRole("agency_business_admin") ||
                UserService.hasRole("agency_system_admin")) && (
                <AddButton
                  label="Add New Project"
                  navigateTo="/add_project"
                  // bgColor="bg-[#00a67e]"
                  iconClassName="h-3 w-3"
                />
              )}
            </div>
          </div>
          {/* <p className="text-gray-600 font-medium">OPEN SKY Super Admin</p> */}
        </div>
        <div className="w-full mx-auto">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center min-h-[400px]">
              <div className="w-16 h-16 border-4 border-[#008564] border-t-transparent rounded-full animate-spin"></div>
              <p className="text-white mt-4 text-lg">Loading projects...</p>
            </div>
          ) : (
            <>
              <div className="flex mt-3 px-2">
                {filteredProjects.length > 0 && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-3 w-full">
                    {filteredProjects.map((project: any) => (
                      <div
                        key={project._id}
                        className="flex flex-col rounded-md border-2 border-[#ffffff] hover:shadow-[0_45px_75px_-18px_rgba(0,0,0,0.5)] overflow-hidden transition-all cursor-pointer"
                        style={{ maxWidth: "462px" }}
                        onClick={() => {
                          const agencySlug = slug || localStorage.getItem("agencySlug") || "";
                          const projectSegment = project.slug || project._id;
                          // Pass project name + location so ProjectDetailsV3's
                          // EntryLoader has real text from frame 1. Agency logo
                          // is NOT passed here — it's sourced from agencyData
                          // (fetched as part of V3's critical loads) so the
                          // loader shows the actual agency logo, not the
                          // project-specific branding image.
                          const lm = project?.address?.landmark || "";
                          const cy = project?.address?.city || "";
                          const locationStr = [lm, cy].filter(Boolean).join(", ");
                          navigate(`/c/${agencySlug}/p/${projectSegment}`, {
                            state: {
                              projectId: project._id,
                              projectName: project.project_name || project.name || "",
                              locationStr,
                            },
                          });
                        }}
                      >
                        {/* Image Section - 462 x 262 */}
                        <div
                          className="relative overflow-hidden bg-white flex-shrink-0"
                          style={{ width: "100%", height: "200px" }}
                        >
                          {project?.logo === null ||
                          project?.logo === undefined ||
                          project?.logo === "" ? (
                            <div className="w-full h-full flex items-center justify-center bg-gray-200">
                              <Icon
                                name="ic-image"
                                className="w-12 h-12 text-gray-400"
                              />
                            </div>
                          ) : (
                            <img
                              src={project?.logo}
                              alt="Property logo"
                              className="w-full h-full object-cover"
                              loading="lazy"
                            />
                          )}
                        </div>

                        {/* Content Section - Remaining 122px */}
                        <div className="flex flex-col px-4 py-3 justify-between gap-2 flex-1 overflow-hidden">
                          <div className="flex items-center justify-between gap-2">
                            <span className="font-normal text-base md:text-lg 2xl:text-xl text-[#FFFFFF] truncate">
                              {project &&
                                capitalizeWords(project?.project_name)}
                            </span>
                          </div>

                          <div className="flex flex-col gap-2">
                            <div className="flex w-full items-center gap-2">
                              <Icon
                                name="ic-location"
                                className="w-5 h-5 flex-shrink-0"
                              />
                              <span className="text-black dark:text-white text-sm flex items-center truncate">
                                {`${toPascalCase(
                                  project?.address?.city,
                                )}, ${toPascalCase(
                                  project?.address?.province,
                                )}, ${toPascalCase(project?.address?.country)}`}
                              </span>
                            </div>

                            <div className="flex w-full gap-2">
                              <Icon
                                name="ic-home"
                                className="w-4 h-4 flex-shrink-0"
                              />
                              <span className="text-black dark:text-white text-sm flex items-center truncate">
                                {getPropertyTypeLabel(project?.project_type)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {projects.length == 0 && (
                <div
                  className={`p-4 bg-[#2E4051] rounded text-center text-white `}
                >
                  No Projects available
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="hidden min-h-screen bg-gray-50 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6 sm:mb-8">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
                  Manage Your Property
                </h1>
                <p className="text-gray-600 mt-2 text-sm sm:text-base">
                  View and manage all your projects in one place
                </p>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/add-project"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm sm:text-base"
                >
                  + Add New Project
                </Link>
                <button
                  onClick={handleExportProjects}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm sm:text-base"
                >
                  Export All
                </button>
                {projects.length > 0 && (
                  <button
                    onClick={handleClearAllProjects}
                    className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 text-sm sm:text-base"
                  >
                    Clear All
                  </button>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="text-sm font-medium text-gray-500">
                  Total Projects
                </h3>
                <p className="text-2xl font-bold text-gray-800 mt-1">
                  {projects.length}
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="text-sm font-medium text-gray-500">
                  Filtered Projects
                </h3>
                <p className="text-2xl font-bold text-gray-800 mt-1">
                  {filteredProjects.length}
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="text-sm font-medium text-gray-500">Villas</h3>
                <p className="text-2xl font-bold text-gray-800 mt-1">
                  {
                    projects.filter(
                      (p) => p.project_type === "villa_gated_community",
                    ).length
                  }
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="text-sm font-medium text-gray-500">
                  Apartments
                </h3>
                <p className="text-2xl font-bold text-gray-800 mt-1">
                  {
                    projects.filter((p) => p.project_type === "apartment")
                      .length
                  }
                </p>
              </div>
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-lg shadow mb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Search Projects
                  </label>
                  <input
                    type="text"
                    placeholder="Search by project name, agency, or location..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Filter by Property Type
                  </label>
                  <select
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                  >
                    <option value="all">All Property Types</option>
                    <option value="villa_gated_community">
                      Villa in Gated Community
                    </option>
                    <option value="apartment">Apartment</option>
                    <option value="farmland">Farmland</option>
                    <option value="bungalow">Bungalow</option>
                    <option value="commercial_space">Commercial Space</option>
                    <option value="layout_gated_community">
                      Layout in Gated Community
                    </option>
                  </select>
                </div>
                <div className="flex items-end">
                  <button
                    onClick={() => {
                      setSearchTerm("");
                      setFilterType("all");
                    }}
                    className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>
          </div>

          {filteredProjects.length === 0 ? (
            <div className="bg-white rounded-lg shadow p-8 text-center">
              <div className="text-gray-400 mb-4">
                <svg
                  className="w-16 h-16 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                No Projects Found
              </h3>
              <p className="text-gray-500 mb-6">
                {searchTerm || filterType !== "all"
                  ? "Try changing your search or filter criteria"
                  : "Get started by adding your first project"}
              </p>
              <Link
                to="/add-project"
                className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Add Your First Project
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProjects.map((project) => {
                const stats = getProjectStats(project);

                return (
                  <div
                    key={project._id}
                    className="bg-white rounded-lg shadow overflow-hidden hover:shadow-lg transition-shadow"
                  >
                    <div className="p-4 sm:p-6 border-b">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h3 className="text-lg sm:text-xl font-bold text-gray-800 truncate">
                            {project.project_name || "Unnamed Project"}
                          </h3>
                          <p className="text-gray-600 text-sm">
                            by {project.agency_name || "Unknown Agency"}
                          </p>
                        </div>
                        <div className="flex flex-col items-end gap-1">
                          <span
                            className={`px-2 py-1 rounded text-xs font-medium ${
                              project.is_active
                                ? "bg-green-100 text-green-800"
                                : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {project.is_active ? "active" : "inactive"}
                          </span>
                          {UserService.hasRole("super_admin") && (
                            <span
                              className="text-xs text-gray-500"
                              title="Lower = higher in list. Edit from project edit form."
                            >
                              Order: {project?.display_order ?? "unset"}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center text-gray-500 text-sm mb-3">
                        <svg
                          className="w-4 h-4 mr-1"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>
                          {project.address?.city || "Unknown Location"}
                        </span>
                      </div>

                      <div className="flex flex-wrap gap-2">
                        <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
                          {stats.type}
                        </span>
                        {project.launch_date && (
                          <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded">
                            {new Date(project.launch_date).toLocaleDateString()}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="p-4 sm:p-6">
                      <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                          <p className="text-xs text-gray-500">Units</p>
                          <p className="font-semibold">{stats.units}</p>
                        </div>
                        {stats.floors && (
                          <div>
                            <p className="text-xs text-gray-500">Floors</p>
                            <p className="font-semibold">{stats.floors}</p>
                          </div>
                        )}
                        {stats.clubhouse && (
                          <div>
                            <p className="text-xs text-gray-500">Clubhouse</p>
                            <p className="font-semibold text-sm">
                              {stats.clubhouse}
                            </p>
                          </div>
                        )}
                        {stats.towers && (
                          <div>
                            <p className="text-xs text-gray-500">Towers</p>
                            <p className="font-semibold">{stats.towers}</p>
                          </div>
                        )}
                      </div>

                      <div className="grid grid-cols-2 gap-2 mt-4">
                        <button
                          onClick={() => handleViewDetails(project)}
                          className="px-3 py-2 bg-blue-50 text-blue-700 rounded hover:bg-blue-100 text-sm font-medium"
                        >
                          View Details
                        </button>
                        <button
                          onClick={() => handleViewUniqueUnits(project)}
                          className="px-3 py-2 bg-green-50 text-green-700 rounded hover:bg-green-100 text-sm font-medium"
                        >
                          Unit Config
                        </button>
                      </div>

                      <div className="flex justify-between items-center mt-6 pt-4 border-t">
                        <button
                          onClick={() => handleDeleteProject(project._id)}
                          className="px-3 py-1.5 text-red-600 hover:text-red-800 text-sm font-medium"
                        >
                          Delete
                        </button>
                        <button className="px-3 py-1.5 text-blue-600 hover:text-blue-800 text-sm font-medium">
                          Edit Project
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {showDetailsModal && selectedProject && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
              <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
                  <h2 className="text-xl font-bold text-gray-800">
                    Project Details
                  </h2>
                  <button
                    onClick={() => setShowDetailsModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="p-6">
                  <div className="mb-8">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                      Project Overview
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <p className="text-sm text-gray-500">Project Name</p>
                        <p className="font-medium">
                          {selectedProject.project_name}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Agency Name</p>
                        <p className="font-medium">
                          {selectedProject.agency_name}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Project Type</p>
                        <p className="font-medium">
                          {getPropertyTypeLabel(selectedProject.project_type)}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Launch Date</p>
                        <p className="font-medium">
                          {new Date(
                            selectedProject.launch_date,
                          ).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mb-8">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                      Location Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-500">Address</p>
                        <p className="font-medium">
                          {selectedProject.address?.address_line1}
                          {selectedProject.address?.address_line2 &&
                            `, ${selectedProject.address.address_line2}`}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">City</p>
                        <p className="font-medium">
                          {selectedProject.address?.city}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Province</p>
                        <p className="font-medium">
                          {selectedProject.address?.province}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Country</p>
                        <p className="font-medium">
                          {selectedProject.address?.country}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sticky bottom-0 bg-gray-50 border-t px-6 py-4 flex justify-end space-x-3">
                  <button
                    onClick={() => setShowDetailsModal(false)}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {showUniqueUnitsModal && selectedProject && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
              <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
                  <div>
                    <h2 className="text-xl font-bold text-gray-800">
                      Unit Configurations
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                      {selectedProject.project_name}
                    </p>
                  </div>
                  <button
                    onClick={() => setShowUniqueUnitsModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="p-6">
                  {selectedUnits.length === 0 ? (
                    <div className="text-center py-8 bg-gray-50 rounded-lg">
                      <p className="text-gray-500">
                        No unit configurations defined for this project
                      </p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 gap-4">
                      {selectedUnits.map((unit, index) => (
                        <div
                          key={index}
                          className="border rounded-lg p-4 hover:bg-gray-50"
                        >
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div>
                              <p className="text-sm text-gray-500">Name</p>
                              <p className="font-medium">{unit.name}</p>
                            </div>
                            <div>
                              <p className="text-sm text-gray-500">BHK</p>
                              <p className="font-medium">{unit.bhk} BHK</p>
                            </div>
                            <div>
                              <p className="text-sm text-gray-500">Size</p>
                              <p className="font-medium">
                                {unit.size_sqft} sqft
                              </p>
                            </div>
                            <div>
                              <p className="text-sm text-gray-500">Count</p>
                              <p className="font-medium">{unit.count} units</p>
                            </div>
                            <div>
                              <p className="text-sm text-gray-500">Facing</p>
                              <p className="font-medium">{unit.facing}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="sticky bottom-0 bg-gray-50 border-t px-6 py-4 flex justify-end">
                  <button
                    onClick={() => setShowUniqueUnitsModal(false)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProjectList;
